/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import upArrow from '../../assets/images/arrow-up-right.svg';
import { ReactComponent as Master } from '../../assets/images/mastercardlogo.svg';
import { ReactComponent as Visa } from '../../assets/images/visalogo.svg';
import { ReactComponent as American } from '../../assets/images/american-express.svg';
import { ReactComponent as Stripe } from '../../assets/images/stripe-badge-transparent 1.svg';
import StripeImg from '../../assets/images/stripe-badge-transparent1.svg';
import { isUserLoggedIn } from '../../utils';
import { notification } from '../../components';

function Footer() {
  const navigate = useNavigate();

  const handleClickContactNumber = (phoneNumber) => {
    const mailtoLink = `tel:${phoneNumber}`;
    window.location.href = mailtoLink;

    setTimeout(() => {
      if (document.hasFocus()) {
        navigator.clipboard.writeText(phoneNumber).then(() => {
          notification({
            type: 'success',
            title: 'Phone number copied',
            description: `${phoneNumber} copied to clipboard`,
          });
        });
      }
    }, 300);
  };

  const footerNavigation = [
    { name: 'Book Appointment', onClick: () => navigate('/choose-location') },
    { name: 'Refund Policy', onClick: () => navigate('/refund-policy') },
    // { name: 'FAQs', onClick: () => navigate('/faqs') },
    { name: 'FAQs', onClick: () => window.open('https://www.simplemri.com/frequently-asked-questions', '_self') },
    ...(isUserLoggedIn() ? [] : [{ name: 'Login/Register', onClick: () => navigate('/login') }]),
    { name: 'Contact Us', onClick: () => navigate('/contact-us') },
    { name: '+1 (786) 744-5616', onClick: () => handleClickContactNumber('+1 (786) 744-5616') },
  ];
  const footerLegals = [
    { name: 'Privacy Policy', onClick: () => navigate('/terms-and-conditions') },
    { name: 'Cookie Policy', onClick: () => navigate('/#') },
  ];
  const footerSocial = [
    { name: 'LinkedIn', onClick: () => window.open('https://www.linkedin.com/company/doctorpatient', '_blank') },
    { name: 'Instagram', onClick: () => window.open('https://www.instagram.com/doctorfare/', '_blank') },
    { name: 'X(Twitter)', onClick: () => window.open('https://twitter.com/doctorfare777', '_blank') },
  ];

  const [showCopiedMessage, setShowCopiedMessage] = useState(false);
  const email = 'support@simplemri.com'; // Replace with your actual support email

  const copyToClipboard = () => {
    navigator.clipboard.writeText(email).then(() => {
      setShowCopiedMessage(true);
      setTimeout(() => setShowCopiedMessage(false), 2000);
    });
  };
  const handleClick = () => {
    const mailtoLink = `mailto:${email}`;
    window.location.href = mailtoLink;

    setTimeout(() => {
      if (document.hasFocus()) {
        copyToClipboard();
      }
    }, 300);
  };

  return (
    <footer className="border-t-[1px] border-t-black pt-4 flex justify-center">
      <div className="grid grid-cols-1 md:flex font-[Poppins] justify-start mx-1 md:w-[90%] lg:w-2/3 lg:mx-8 mt-7">
        <div className="flex flex-col md:basis-1/2">
          <p className="font-normal text-[2rem] md:text-[3rem] text-center md:text-start">Get in touch</p>
          {/* <p className="font-normal text-[1rem] -mt-2">with our news letter</p> */}
          <div className="flex relative w-[21rem] mt-2 mb-4 md:mx-0 mx-auto items-center p-[0.75rem] rounded-full border-[#D9D9D9] border-[1px]">
            <p>support@simplemri.com</p>
            <button className="flex items-center gap-3 border-[#222222] border-[2px] absolute right-1 rounded-full p-1" onClick={handleClick}>
              <p className="pl-1 text-[#222222] font-normal text-[0.75rem] font-[Poppins]">Connect</p>
              <div className="bg-[#222222] rounded-full p-1">
                <img src={upArrow} alt="up" width="20px" height="20px" />
              </div>
            </button>

          </div>
          <div className=" items-center gap-1 border-b-[#D9D9D9] border-b-[1px] w-min mt-10 hidden md:flex">
            {/* <Paypal /> */}
            {/* {' '}
            <Master />
            {' '}
            <Visa />
            {' '}
            <American /> */}
            <Stripe />
          </div>
          <p className="text-[#222222] text-sm hidden md:block">
            @Doctorfare
            {new Date().getFullYear()}
            , All rights reserved.
          </p>
        </div>
        <div className="flex flex-col basis-1/4">
          <div>
            <h4 className="font-normal text-xl text-center md:text-left mb-3">Quick Links</h4>
            <div className=" my-4">
              {
                footerNavigation.map((el) => <button type="button" key={el.name} onClick={el.onClick} className="text-lg my-1 md:text-base w-full md:block md:w-max block">{el.name}</button>)
              }
            </div>
          </div>

        </div>
        <div className="flex flex-col basis-1/4">
          <div className="text-center md:text-left">
            <h4 className="font-normal text-xl text-center md:text-left mb-1">Follow Us</h4>
            <div className=" my-4">
              {
                footerSocial.map((el) => <button type="button" key={el.name} onClick={el.onClick} className="text-lg my-1 md:text-base w-full md:block md:w-max block">{el.name}</button>)
              }
            </div>
          </div>
          <div className="mt-1">
            <h4 className="font-normal text-xl text-center md:text-left mb-3">Legal</h4>
            <div className=" my-4">
              {
                footerLegals.map((el) => <button type="button" key={el.name} onClick={el.onClick} className="text-lg my-1 md:text-base w-full md:block md:w-max block">{el.name}</button>)
              }
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className=" items-center gap-1 border-b-[#D9D9D9] border-b-[1px] mx-1 mt-10 flex md:hidden">
            {/* <Master className="scale-95" />
            {' '}
            <Visa className="scale-95" />
            {' '}
            <American className="scale-95" /> */}
            <img src={StripeImg} alt="StripeImg" />
          </div>
          {/* <p className="text-[#222222] text-sm md:hidden"> */}
          <p className="text-[#222222] text-sm hidden md:block">
            @Doctorfare
            { new Date().getFullYear() }
            , All rights reserved.
          </p>

          <p className="text-[#222222] text-sm text-center w-full md:hidden block">
            @Doctorfare
            {new Date().getFullYear()}
            , All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
